// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.properties-view-entity table th[data-v-4922190e] {
  max-width: 13rem;
}
.properties-view-entity table td pre[data-v-4922190e] {
  white-space: pre-wrap;
}
.properties-view-entity ul.labels[data-v-4922190e] {
  list-style-type: none;
}
.properties-view-entity ul.labels li[data-v-4922190e] {
  float: left;
  padding: 0.1rem 0.4rem;
  background-color: #39748c;
  margin: 0.2rem 0.2rem;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/renderers/properties-view-renderer/properties-view.vue"],"names":[],"mappings":"AAIE;EACC,gBAAA;AAHH;AAQG;EACC,qBAAA;AANJ;AAWC;EACC,qBAAA;AATF;AAWE;EACC,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;AATH","sourcesContent":["\n\n.properties-view-entity {\n\ttable {\n\t\tth {\n\t\t\tmax-width: 13rem;\n\t\t}\n\n\t\ttd {\n\n\t\t\tpre {\n\t\t\t\twhite-space: pre-wrap;\n\t\t\t}\n\t\t}\n\t}\n\n\tul.labels {\n\t\tlist-style-type: none;\n\n\t\tli {\n\t\t\tfloat: left;\n\t\t\tpadding: 0.1rem 0.4rem;\n\t\t\tbackground-color: #39748c;\n\t\t\tmargin: .2rem .2rem;\n\t\t\tcolor: white;\n\t\t}\n\t}\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
